module.exports = __webpack_public_path__ + "87e0cf1ced0ab1b4d0b0d13d401165a4.svg";